import React, { useEffect } from "react";
import { compose } from "ramda";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router";
import CheckoutContainer from "./checkout/CheckoutContainer";
import EnrollmentPreviewPage from "./EnrollmentPreviewPage";
import { getEnrolmentSettings } from "../../../actions/enrollmentActions";
import { Loader } from "@cxagroup/casper/lib/components";

const EnrollmentPreviewSwitcher = props => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEnrolmentSettings());
  }, []);

  const clientSettings = useSelector(state => state.common.clientSettings);
  const enrollmentSettings = useSelector(state => state.enrollment.settings);
  if (!enrollmentSettings) return <Loader />;

  return clientSettings &&
    clientSettings.newUIFlag &&
    enrollmentSettings &&
    enrollmentSettings.enableBenefitSelectionForNewUIUX ? (
    <EnrollmentPreviewPage {...props} />
    ) : (
    <CheckoutContainer {...props} />
  );
};

export default compose(withRouter)(EnrollmentPreviewSwitcher);



// WEBPACK FOOTER //
// ./components/employee/shop/EnrollmentPreviewSwitcher.js